export const PAGINATION_STYLES = {
  '& .MuiPaginationItem-root': {
    color: '#b0b0b0',
    backgroundColor: '#2a2a2a',
    border: '1px solid #444',
    borderRadius: '50%',
    minWidth: '40px',
    height: '40px',
    width: '40px',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: '#ffa900',
      color: '#000',
      fontWeight: 600,
    },
    '&.Mui-selected': {
      backgroundColor: '#ffa900',
      color: '#000',
      fontWeight: 600,
    },
    // Mobile responsive styles
    '@media (max-width: 768px)': {
      minWidth: '32px',
      height: '32px',
      width: '32px',
      fontSize: '12px',
    },
    '@media (max-width: 480px)': {
      minWidth: '28px',
      height: '28px',
      width: '28px',
      fontSize: '11px',
    },
  },
  // Hide some pagination items on mobile to prevent overflow
  '@media (max-width: 768px)': {
    '& .MuiPagination-ul': {
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
  },
  '@media (max-width: 480px)': {
    '& .MuiPagination-ul': {
      gap: '4px',
    },
  },
}
